import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import jsPDF from "jspdf";
import "jspdf-autotable";
import React, { useRef } from "react";

// ========== Utility Functions ==========

const numberToWords = (num) => {
  if (num === null || num === undefined) return "Zero";

  const a = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];

  const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  const convert = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    if (n < 1000)
      return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + convert(n % 100) : "");
    if (n < 100000)
      return convert(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + convert(n % 1000) : "");
    if (n < 10000000)
      return convert(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + convert(n % 100000) : "");
    if (n < 1000000000)
      return (
        convert(Math.floor(n / 10000000)) +
        " Crore" +
        (n % 10000000 ? " " + convert(n % 10000000) : "")
      );
    return n;
  };

  // Split taka and paisa
  const parts = num.toString().split(".");
  const taka = parseInt(parts[0], 10);
  const paisa = parts[1] ? parseInt(parts[1].padEnd(2, "0").slice(0, 2), 10) : 0;

  let words = "";

  if (taka > 0) {
    words += `${convert(taka)} Taka`;
  }

  if (paisa > 0) {
    if (words) words += " and ";
    words += `${convert(paisa)} Paisa`;
  }

  if (!words) return "Zero";

  return words;
};

const toTitleCaseKeepAcronyms = (str) => {
  const acronyms = ["PLC", "LTD", "AB"];
  if (!str) return "-";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => acronyms.includes(word.toUpperCase()) ? word.toUpperCase() :
      word.split("-").map(part => part.charAt(0).toUpperCase() + part.slice(1)).join("-")
    )
    .join(" ");
};

// ========== Main Component ==========

function SettlementTransferModal({ open, onClose, requestData }) {

  const printRef = useRef();

  const handleDownload = () => {
    const doc = new jsPDF("p", "mm", "a4");
    const clone = printRef.current.cloneNode(true);
    clone.style.fontSize = "13pt";
    clone.style.color = "black";
    clone.style.backgroundColor = "white";

    doc.html(clone, {
      callback: () => doc.save(`Fund-Transfer-${requestData.refNo}.pdf`),
      margin: [30, 10, 10, 10],
      autoPaging: "text",
      x: 10,
      y: 10,
      width: 180,
      windowWidth: 1000,
    });
  };

  const renderTableRows = () => {
    return requestData.settledEftDetails.map((detail, idx) => {
      const bankName = detail.bank?.bankName || "-";
      const branchName = detail.bank?.branchName || "-";
      const routingNo = detail.bank?.routingNo || "-";
      const accountNo = detail.bAccountNo || "-";

      return (
        <tr key={detail.id}>
          <td>{idx + 1}</td>
          <td>{detail.name}</td>
          <td>{toTitleCaseKeepAcronyms(bankName)}</td>
          <td>{toTitleCaseKeepAcronyms(branchName)}</td>
          <td>{accountNo}</td>
          <td>{routingNo}</td>
          <td style={{ textAlign: "right" }}>
            {new Intl.NumberFormat("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(detail.totalAmount) || 0)}
          </td>
        </tr>
      );
    });
  };

  if (!requestData) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Fund Transfer Details (Settlement)</DialogTitle>
      <DialogContent>
        <div ref={printRef} style={{ padding: "10px", fontFamily: "Times New Roman" }}>

          {/* Header Section */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div><strong>Ref No: </strong> {requestData.refNo}</div>
            
            <div>
              <strong>Date: </strong>
              {new Date(requestData.date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
            </div>
          </div>
          <br></br>
         
          <p><strong>Manager<br />{requestData.bankBo.companyName}<br />{requestData.bankBo.branch}<br />{requestData.bankBo.address}</strong></p>

          <p>Subject: <strong>{requestData.subject}</strong></p>
          <p>Dear Sir,</p>

          <p>
            Please transfer the following fund from our special notice deposit bank
            account no. <strong>{requestData.bankBo.accountNumber}</strong> maintained
            with your bank to the respective bank account of the beneficiaries as
            per the information given below:
          </p>

       <table
  width="100%"
  style={{ borderCollapse: "collapse", marginTop: "10px", border: "1px solid black" }}
>
  <thead>
    <tr style={{ textAlign: "center", backgroundColor: "#f2f2f2" }}>
      <th style={{ border: "1px solid black", padding: "5px" }}>Sl. No</th>
      <th style={{ border: "1px solid black", padding: "5px" }}>Name </th>
        <th style={{ border: "1px solid black", padding: "5px" }}>Issuer Name </th>
      <th style={{ border: "1px solid black", padding: "5px" }}>Bank Name</th>
      <th style={{ border: "1px solid black", padding: "5px" }}>Branch Name</th>
      <th style={{ border: "1px solid black", padding: "5px" }}>Bank A/C No.</th>
      <th style={{ border: "1px solid black", padding: "5px" }}>Routing No.</th>
      <th style={{ border: "1px solid black", padding: "5px" }}>Amount (BDT)</th>
    </tr>
  </thead>
<tbody>
  {requestData.settledEftDetails.map((detail, idx) => {
    const bankName = detail.bank?.bankName || "-";
    const branchName = detail.bank?.branchName || "-";
    const routingNo = detail.bank?.routingNo || "-";
    const accountNo = detail.accountNo || "-";

    // Conditional row style based on status
    const rowStyle = {
      1: { backgroundColor: "white" },      // Normal
      2: { backgroundColor: "#fce7e7ff" },    // Light red
    };

    const appliedRowStyle = rowStyle[detail.status] || { backgroundColor: "#fff3cd" }; // Yellow for others

    return (
      <tr key={detail.id} style={appliedRowStyle}>
        <td style={{ border: "1px solid black", padding: "5px", textAlign: "center" }}>
          {idx + 1}
        </td>

        <td style={{ border: "1px solid black", padding: "5px", textAlign: "center" }}>
          {detail.fullName}
        </td>

        <td style={{ border: "1px solid black", padding: "5px", textAlign: "center" }}>
          {detail.issuer.name}
        </td>

        <td style={{ border: "1px solid black", padding: "5px", textAlign: "center" }}>
          {toTitleCaseKeepAcronyms(bankName)}
        </td>

        <td style={{ border: "1px solid black", padding: "5px", textAlign: "center" }}>
          {toTitleCaseKeepAcronyms(branchName)}
        </td>

        <td style={{ border: "1px solid black", padding: "5px", textAlign: "center" }}>
          {accountNo}
        </td>

        <td style={{ border: "1px solid black", padding: "5px", textAlign: "center" }}>
          {routingNo}
        </td>

        <td style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>
          {detail.status === 2 ? (
            <del>
              {new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              }).format(Number(detail.amount) || 0)}
            </del>
          ) : (
            new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }).format(Number(detail.amount) || 0)
          )}
        </td>
      </tr>
    );
  })}

  <tr>
    <td
      colSpan="7"
      style={{ textAlign: "right", border: "1px solid black", padding: "5px" }}
    >
      <strong>Total</strong>
    </td>
    <td style={{ border: "1px solid black", padding: "5px", textAlign: "right" }}>
      <strong>
        {new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(Number(requestData.totalAmount) || 0)}
      </strong>
    </td>
  </tr>
</tbody>

</table>


          <p><strong>Amount in word (BDT):</strong> {numberToWords(Number(requestData.totalAmount))} only.</p>

          <p>Kindly execute the fund transfer instruction as stated above by debiting our bank account and transmit us the transfer advice in due 
           course.</p>
          <p>Thanks and best regards,</p>

          {/* Signatures */}
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "80px" }}>
            {[requestData.secondarySignatory, requestData.primarySignatory].map((signatory, idx) => (
              <div key={idx}>
                <strong>({signatory.fullName})</strong><br />
                {signatory.designation}<br />
                {requestData.orgName}
              </div>
            ))}
          </div>

        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleDownload} color="primary" variant="contained">Download</Button>
        <Button onClick={onClose} color="secondary">Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default SettlementTransferModal;
